var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_14982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.875 12.2719C22.875 18.9047 18.3328 23.625 11.625 23.625C5.19375 23.625 0 18.4312 0 12C0 5.56875 5.19375 0.375 11.625 0.375C14.7563 0.375 17.3906 1.52344 19.4203 3.41719L16.2562 6.45938C12.1172 2.46563 4.42031 5.46563 4.42031 12C4.42031 16.0547 7.65938 19.3406 11.625 19.3406C16.2281 19.3406 17.9531 16.0406 18.225 14.3297H11.625V10.3312H22.6922C22.8 10.9266 22.875 11.4984 22.875 12.2719Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_14982"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22.875V24H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.615f235a54ce333c8bd73f463e2a9d07.svg";
export { ForwardRef as ReactComponent };